import { Component, Input } from '@angular/core';

import { MAX_TEXT_LENGTH } from '../../model/constants';

@Component( {
    selector: 'res-collapsible-text-view',
    templateUrl: './collapsible-text-view.component.html'
} )
export class CollapsibleTextViewComponent {
    @Input() text: string;
    @Input() header = '';
    @Input() expandToolTip = '';
    @Input() collapseToolTip = '';
    @Input() hisobject: any;
    @Input() hisAttribute: string;

    public showFullText = false;
    public maxLength = MAX_TEXT_LENGTH;

    /* set to show the full/shortened text */
    public setShowFullText( showFullText: boolean ): void {
        this.showFullText = showFullText;
    }

    /* compares the text.length to the specified maximum */
    public isMaxTextLength(): boolean {
        return this.text && this.text.length > MAX_TEXT_LENGTH;
    }

    /* substring text to max 620 or last full word */
    public getMaxTextLength( text: string ): string {
        let textLength = MAX_TEXT_LENGTH;
        while ( ( text.charAt( textLength ) !== ' '
            || text?.charAt( textLength ).match( '\n' ) ) && textLength !== 0 ) {
            textLength--;
        }
        return text.substring( 0, textLength ) + ' ...';
    }
}
